import React from "react";
import {
  Checkbox,
  CheckboxGroup,
  Flex,
  Heading,
  Text,
  Link,
} from "@chakra-ui/react";

function Card({ region, description, amazon_url }) {
  return (
    <Flex direction="column" p={8} boxShadow="base">
      <Flex justify="space-between">
        <Heading size="sm">{description}</Heading>
        <Checkbox defaultChecked={false}> Filled WishList </Checkbox>
      </Flex>
      <Text>Region: {region}</Text>
      <Link href={amazon_url}>Open wishlist</Link>
    </Flex>
  );
}

export default Card;
